import { Component, inject, ChangeDetectionStrategy } from '@angular/core';

import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { MatIconModule } from '@angular/material/icon';
import { GalaxyAiIconService } from '@vendasta/galaxy/ai-icon';

@Component({
  selector: 'inbox-ai-badge',
  imports: [GalaxyBadgeModule, MatIconModule],
  templateUrl: './Inbox-ai-badge.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './inbox-ai-badge.component.scss',
})
export class InboxAiBadgeComponent {
  aiIconService = inject(GalaxyAiIconService);
}
